module.exports = __webpack_public_path__ + "static/img/120.d69c5b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/120.png
// module id = 8Jqq
// module chunks = 0